import { useSyncExternalStore } from 'react';
import {
  getOfflineSettings,
  subscribeToOfflineSettings,
  type OfflineSettings,
} from '@/services/offlineSettings';

export const useOfflineSettings = (): OfflineSettings =>
  useSyncExternalStore(subscribeToOfflineSettings, getOfflineSettings, getOfflineSettings);

export default useOfflineSettings;
